import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import editProfileUser from "../../../assets/images/others/host-side-images/editProfileUSer.png";
import { ReactComponent as EditProfilePersonal } from "../../../assets/images/svgs/edit-profiles.svg";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "../../../components/breadcrumbs/AttendeeBreadcrumb";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import useStore from "hooks/useStore";
import { GENDERS } from "utils/helpers/enums/shared.enum";
import { CompleteAttendeeProfileDTO } from "utils/helpers/models/attendee/complete-profile.dto";
import useMinor from "../useHooks";
import { MinorProfileDTO } from "utils/helpers/models/minor/edit-profile.dto";
import { min } from "date-fns";
import MinorBreadcrumb, {
  MinorBreadcrumbLink,
} from "components/breadcrumbs/MinorBreadcrumb";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { warningToaster } from "utils/helpers/common/alert-service";

import statesData from "components/dummyData/states.json";

const statesList = statesData.states;

const MinorEditProfile: React.FC = () => {
  const [formData, setFormData] = useState<MinorProfileDTO>(
    new MinorProfileDTO()
  );
  const [minorProfileData, setMinorProfileData] = useState<MinorProfileDTO>(
    new MinorProfileDTO()
  );
  const [cityList, setCityList] = useState<string[]>([]);
  console.log(cityList, "cityList");
  const { updateMinor, uploadFile, getMinorProfile } = useMinor();
  const breadcrumbLinks: MinorBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.minorHome },
    { title: "Edit Profile", path: siteRoutes.minorEditProfile },
  ];

  useEffect(() => {
    getMinorProfile(setMinorProfileData);
  }, []);

  const { getUser } = useStore();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm<MinorProfileDTO>({
    defaultValues: {
      address: formData?.address || '',
      zipCode: formData?.zipCode || '',
      state: formData?.state || '',
      city: formData?.city || '',

    },
  });

  const [profileImage, setProfileImage] = useState<string | null>(null);

  useEffect(() => {
    if (minorProfileData?.profilePicUrl?.fileDownloadUri) {
      setProfileImage(minorProfileData?.profilePicUrl?.fileDownloadUri);
    }
  }, [minorProfileData]);


  useEffect(() => {
    if (formData?.state) {
      const selectedState = statesList.find(
        (state: any) => state.name === formData.state
      );
      if (selectedState && selectedState.cities) {
        setCityList(selectedState.cities.map((city: any) => city.name));
      }
    }
  }, [formData?.state, statesList]);


  useEffect(() => {
    if (minorProfileData) {
      reset({
        firstName: minorProfileData.firstName || "",
        lastName: minorProfileData.lastName || "",
        state: minorProfileData.state || "",
        address: minorProfileData.address || "",
        language: minorProfileData.language || "",
        dob: minorProfileData.dob || "",
        gender: minorProfileData.gender || "",
        zipCode: minorProfileData.zipCode || "",
        city: minorProfileData.city || "",
        profilePicId: minorProfileData?.profilePicUrl?.id || 0,
        profilePicUrl: minorProfileData?.profilePicUrl?.fileDownloadUri || "",
      });
      setFormData({
        ...minorProfileData,
      });
    }
  }, [minorProfileData, reset]);




  const { user } = getUser();
  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setProfileImage(previewUrl);
      setValue("profilePicUrl", file.name, { shouldValidate: true });

      try {
        const uploaded = await uploadFile(file);
        if (uploaded?.id) {
          setValue("profilePicId", uploaded.id, { shouldValidate: true });
        }
      } catch (error) {
        console.error("Upload failed", error);
      }
    }
  };


  const handleChange = (event: any) => {
    const {
      target: { value, name },
    } = event;
    setValue(name, value, { shouldValidate: true });
    setFormData({ ...formData, [name]: value });

    if (name === "state") {
      const selectedState = statesList.find(
        (state: any) => state.name === value
      );

      console.log("Selected State:", value);

      if (selectedState && selectedState.cities) {
        setCityList(selectedState.cities.map((city: any) => city.name));
      } else {
        setCityList([]);
      }
      // Reset city when state changes
      setValue("city", "");
      setFormData((prev) => ({ ...prev, city: "" }));
    }
  };

  const onSubmit: SubmitHandler<MinorProfileDTO> = (data) => {
    data.firstName = minorProfileData.firstName;
    data.lastName = minorProfileData.lastName;
    data.language = minorProfileData.language;
    data.dob = minorProfileData.dob;
    data.gender = minorProfileData.gender;
    if (!data.profilePicId) {
      warningToaster(
        "Please upload a profile picture before updating your profile."
      );
      return;
    }
    updateMinor(user?.id, data);
  };

  return (
    <div className="container ">
      <MinorBreadcrumb links={breadcrumbLinks} />

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Profile Picture */}
        <div className="flex flex-col  my-8">
          <div className="relative">
            <img
              src={concatPathWithBackendUrl(profileImage) || editProfileUser}
              alt="Profile"
              className="w-36 h-36 rounded-full object-cover"
            />
            <label
              htmlFor="profileImage"
              className="absolute bottom-0 left-24 bg-white shadow p-2 rounded-full cursor-pointer"
            >
              <EditProfilePersonal />
            </label>
            <input
              id="profileImage"
              type="file"
              accept="image/*"
              className="hidden"
              {...register("profilePicId", {
                required: false,
              })}
              onChange={handleImageChange}
            />
          </div>
          {errors.profilePicId && (
            <p className="text-red-500 text-sm mt-2">
              {errors.profilePicId.message}
            </p>
          )}
          <p className="text-base font-semibold mt-4">Upload Profile Picture</p>
        </div>

        {/* Form Fields */}
        <div className="w-full my-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {/* First Name */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              First name
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none cursor-not-allowed"
              {...register("firstName", { required: "First name is required" })}
              // value={formData.firstName}
              // onChange={onChangeAdress}
              disabled
            />
            {errors.firstName && (
              <p className="text-red-500 text-sm">{errors.firstName.message}</p>
            )}
          </div>

          {/* Last Name */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Last name
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none cursor-not-allowed"
              {...register("lastName", { required: "Last name is required" })}
              disabled
            />
            {errors.lastName && (
              <p className="text-red-500 text-sm">{errors.lastName.message}</p>
            )}
          </div>

          {/* Language */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Language
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none cursor-not-allowed"
              {...register("language", { required: "Language is required" })}
              disabled
            />
            {errors.language && (
              <p className="text-red-500 text-sm">{errors.language.message}</p>
            )}
          </div>

          {/* Date of Birth */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Date of Birth
            </label>
            <input
              type="date"
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none cursor-not-allowed"
              {...register("dob", { required: "Date of Birth is required" })}
              disabled
            />
            {errors.dob && (
              <p className="text-red-500 text-sm">{errors.dob.message}</p>
            )}
          </div>

          {/* Gender */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">Gender</label>
            <select
              className="w-full h-[51px] px-2 rounded-lg border border-inputsBorderColor outline-none cursor-not-allowed"
              {...register("gender", { required: "Gender is required" })}
              disabled
            >
              <option value="">Select Gender</option>
              {Object.values(GENDERS).map((gender, index) => {
                return (
                  <option className="capitalize" value={gender} key={index}>
                    {gender}
                  </option>
                );
              })}
            </select>
            {errors.gender && (
              <p className="text-red-500 text-sm">{errors.gender.message}</p>
            )}
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Address
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border-[0.6px] border-inputsBorderColor outline-none"
              {...register("address", {
                required: "Address is required",
              })}
              value={formData.address}
              onChange={handleChange}
            />

            {errors.address && (
              <p className="text-red-500 text-sm">{errors.address.message}</p>
            )}
          </div>

          {/* State Dropdown */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">State</label>
            <select
              // name="state"
              className="w-full h-[51px] px-2 rounded-lg border-[0.6px] border-inputsBorderColor outline-none"
              {...register("state", { required: "State is required" })}
              value={formData.state}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select
              </option>
              {statesList.map((state: any) => (
                <option key={state.id} value={state.name}>
                  {state.name}
                </option>
              ))}
            </select>
            {errors.state && (
              <p className="text-red-500 text-sm">{errors.state.message}</p>
            )}
          </div>

          {/* City Dropdown */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">City</label>
            <select
              name="city"
              className="w-full h-[51px] px-2 rounded-lg border-[0.6px] border-inputsBorderColor outline-none"
              {...register("city", { required: "City is required" })}
              value={formData.city}
              onChange={handleChange}
            >
              <option value="" disabled defaultValue={minorProfileData.city}>
                Select
              </option>
              {cityList.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
            {errors.city && (
              <p className="text-red-500 text-sm">{errors.city.message}</p>
            )}
          </div>

          {/* Zip Code Input */}
          <div className="flex flex-col gap-1">
            <label className="text-label text-base font-semibold">
              Zip Code
            </label>
            <input
              type="text"
              className="w-full h-[51px] px-2 rounded-lg border-[0.6px] border-inputsBorderColor outline-none"
              {...register("zipCode", {
                required: "Zip code is required",
                pattern: {
                  value: /^[0-9]{5}(?:-[0-9]{4})?$/,
                  message: "Please enter a valid ZIP code",
                },
              })}
              value={formData.zipCode}
              onChange={handleChange}
            />
            {errors.zipCode && (
              <p className="text-red-500 text-sm">{errors.zipCode.message}</p>
            )}
          </div>
        </div>
        <button
          type="submit"
          className="px-4 py-2 bg-primaryBlueBg text-white rounded-full mt-4 md:mt-8"
        >
          Update
        </button>
      </form>
    </div>
  );
};

export default MinorEditProfile;
